module.exports = __webpack_public_path__ + "static/img/品牌logo@3x.25f4b55.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/首页/品牌logo@3x.png
// module id = DC1O
// module chunks = 192